import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'

export class UIGameConstants {
    static CARD_RATIO = 400 / 285 // Height / Width of cards
    static TILE_RATIO = 400 / 346 // Height / Width of tiles

    static GAME_WORLD_ZOOM_CLAMP_MULTIPLIER = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? 4 : 2.5
}
